const URIs = {
  //**login */
  login: "login",
  get_user: "/api/user/login",

  //**pdf upload */
  pdf_upload: "/api/pt/pdf",

  //** pdf-img */
  get_pdf_img: "/api/pt/pdf-img",

  //** PT */
  post_pt_video: "/api/pt/video",
  post_pt_slide_history: "/api/pt/slide-history",
  get_pt_video: "/api/pt/video",
  get_pt_slide_history: "/api/pt/slide-history",
  get_pt_slide_event: "/api/pt/slide-event"
};

export default URIs;
